export default {
  props: {
    likeClientX: {
      type: Number,
      default: 0
    },
    likeClientY: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      timer: null,
      apngSrc: 'https://vercel-static.bj.bcebos.com/stash/v1/2a7fbac/feed-h5/b7193d7/lottie/likeA3.png',
      // APNG 图片的 URL
      animationInProgress: false // 是否正在播放动画
    };
  },

  computed: {
    clientX() {
      return `${this.likeClientX}px`;
    },
    clientY() {
      return `${this.likeClientY}px`;
    }
  },
  created() {
    this.apngSrc += `? + ${Date.now()}`;
    this.startAnimation();
  },
  mounted() {},
  methods: {
    startAnimation() {
      if (this.animationInProgress) {
        return;
      }
      this.animationInProgress = true;
      this.getAPNGDuration();
    },
    getAPNGDuration() {
      clearTimeout(this.timer);
      this.timer = null;
      // 模拟动画播放时间为1秒钟
      this.timer = setTimeout(() => {
        this.animationInProgress = false;
        clearTimeout(this.timer);
        this.timer = null;
      }, 1000);
    }
  }
};